// extracted by mini-css-extract-plugin
export default {"btnCol":"AddPropertyCard_btnCol__0D1Th","btnDiv":"AddPropertyCard_btnDiv__Or-Qa","btn":"AddPropertyCard_btn__RzLNR","textDiv":"AddPropertyCard_textDiv__88AWr"};